module.exports = __webpack_public_path__ + "static/media/AvatarJonathan.b2254d51.png";